import acAjaccio from '../assets/images/logos/ac-ajaccio.png'
import acArles from '../assets/images/logos/ac-arles.png'
import ajAuxerre from '../assets/images/logos/aj-auxerre.png'
import amiensSc from '../assets/images/logos/amiens-sc.png'
import angersSco from '../assets/images/logos/angers-sco.png'
import asMonaco from '../assets/images/logos/as-monaco.png'
import asNancyLorraine from '../assets/images/logos/as-nancy-lorraine.png'
import asSaintEtienne from '../assets/images/logos/as-saint-etienne.png'
import chamoisNiortais from '../assets/images/logos/chamois-niortais-fc.png'
import clermontFoot from '../assets/images/logos/clermont-foot.png'
import csSedanArdennes from '../assets/images/logos/cs-sedan-ardennes.png'
import dijonFco from '../assets/images/logos/dijon-fco.png'
import eaGuingamp from '../assets/images/logos/ea-guigamp.png'
import estacTroyes from '../assets/images/logos/estac-troyes.png'
import fcGirondinsDeBordeaux from '../assets/images/logos/fc-girondins-de-bordeaux.webp'
import fcGueugnon from '../assets/images/logos/fc-gueugnon.png'
import fcLorient from '../assets/images/logos/fc-lorient.png'
import fcMetz from '../assets/images/logos/fc-metz.png'
import fcNantes from '../assets/images/logos/fc-nantes.png'
import fcSochauxMontbeliard from '../assets/images/logos/fc-sochaux-montbeliard.png'
import gazelecFcAjaccio from '../assets/images/logos/gazelec-fc-ajaccio.png'
import grenobleFoot from '../assets/images/logos/grenoble-foot.png'
import istresFc from '../assets/images/logos/istres-fc.png'
import leHavreAc from '../assets/images/logos/le-havre-ac.png'
import leMansFc from '../assets/images/logos/le-mans-fc.png'
import loscLille from '../assets/images/logos/losc-lille.webp'
import montpellierHsc from '../assets/images/logos/montpellier-hsc.png'
import nimesOlympique from '../assets/images/logos/nimes-olympique.png'
import ogcNice from '../assets/images/logos/ogc-nice.png'
import olympiqueDeMarseille from '../assets/images/logos/olympique-de-marseille.png'
import olympiqueLyonnais from '../assets/images/logos/olympique-lyonnais.png'
import parisSaintGermain from '../assets/images/logos/paris-saint-germain.webp'
import rcLens from '../assets/images/logos/rc-lens.png'
import rcStrasbourg from '../assets/images/logos/rc-strasbourg.png'
import scBastia from '../assets/images/logos/sc-bastia.png'
import stadeBrestois from '../assets/images/logos/stade-brestois-29.png'
import stadeDeReims from '../assets/images/logos/stade-de-reims.png'
import stadeLavallois from '../assets/images/logos/stade-lavallois.png'
import stadeMalherbeCaen from '../assets/images/logos/stade-malherbe-caen.png'
import stadeRennaisFc from '../assets/images/logos/stade-rennais-fc.png'
import thononEvianGgfc from '../assets/images/logos/thonon-evian-ggfc.png'
import toulouseFc from '../assets/images/logos/toulouse-fc.png'
import usBoulogne from '../assets/images/logos/us-boulogne.png'
import valenciennesFc from '../assets/images/logos/valenciennes-fc.png'

export const logos = {
  'AC Ajaccio': acAjaccio,
  'AC Arles-Avignon': acArles,
  'AJ Auxerre': ajAuxerre,
  'Amiens SC': amiensSc,
  'Angers SCO': angersSco,
  'AS Monaco': asMonaco,
  'AS Nancy Lorraine': asNancyLorraine,
  'AS Saint-Étienne': asSaintEtienne,
  'Chamois Niortais FC': chamoisNiortais,
  'Clermont Foot 63': clermontFoot,
  'CS Sedan Ardennes': csSedanArdennes,
  "Dijon Football Côte-d'Or": dijonFco,
  'En Avant Guingamp': eaGuingamp,
  'ES Troyes AC': estacTroyes,
  'Évian Thonon Gaillard FC': thononEvianGgfc,
  'FC Guegnon': fcGueugnon,
  'FC Istres': istresFc,
  'FC Lorient': fcLorient,
  'FC Metz': fcMetz,
  'FC Nantes': fcNantes,
  'FC Sochaux-Montbéliard': fcSochauxMontbeliard,
  'Gazelec FC Ajaccio': gazelecFcAjaccio,
  'Girondins de Bordeaux': fcGirondinsDeBordeaux,
  'Grenoble Foot 38': grenobleFoot,
  'Le Havre AC': leHavreAc,
  'Le Mans FC': leMansFc,
  'LOSC Lille': loscLille,
  'Montpellier HSC': montpellierHsc,
  'Nîmes Olympique': nimesOlympique,
  'OGC Nice': ogcNice,
  'Olympique de Marseille': olympiqueDeMarseille,
  'Olympique Lyonnais': olympiqueLyonnais,
  'Paris Saint-Germain': parisSaintGermain,
  'RC Lens': rcLens,
  'RC Strasbourg': rcStrasbourg,
  'SC Bastia': scBastia,
  'Stade Brestois 29': stadeBrestois,
  'Stade de Reims': stadeDeReims,
  'Stade Lavallois': stadeLavallois,
  'Stade Malherbe de Caen': stadeMalherbeCaen,
  'Stade Rennais FC': stadeRennaisFc,
  'US Boulogne': usBoulogne,
  'Toulouse FC': toulouseFc,
  'Valenciennes FC': valenciennesFc,
}
